export default __webpack_public_path__ + "static/media/smu_logo.2295ad71.png";